function InsightArticleController(){
	this.className			= "InsightArticleController";
	this.view				= false; //"example";
	this.glob				= ["/press-commentary/market-insights/*/*"];
	this.globMain 			= true;
    this.log                = false;
    this.cache				= true;
}

InsightArticleController.inheritsFrom( PageController );

InsightArticleController.prototype.setup = function(onComplete){
	if(this.isSetup) return;
	this.$body = $('body');
	this.$page  = this.$body.find('.js-page');
	this.isSetup = true;
}

InsightArticleController.prototype.swapMain = function(onComplete){
	return this.swap(onComplete);
}

InsightArticleController.prototype.swap = function(onComplete){
    if(!this.isSetup) this.setup();

	this.hashNav = nav.part(3) ? nav.part(3) : false;
	if(this.hashNav) {
		$('html,body').animate({scrollTop: $('#'+this.hashNav).offset().top},'fast');	
	}

	this.leftNav 	 	= $('.insight-navigation');
	this.leftNavLinks 	= this.leftNav.find('a');


	// commented out until needed (gives active link the dash prepend)
	
 //    this.$lhsNavigation = this.$page.find('.left-navigation');
 //    this.$lhsLinks		= this.$lhsNavigation.find('a');

 //    this.$lhsLinks.off('click').on("click", (e) => {
	// 	const $this = $(e.currentTarget);

	// 	this.$lhsLinks.removeClass('active');
	// 	$this.addClass('active');
	// });
}